import { fieldIdsPanel as fieldIdsPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'
import type { I18nextProviderProps } from 'react-i18next'
import type {
  EditorSDK,
  FieldIdsPanelInitialData,
} from '@wix/wix-data-client-common-standalone'

export const openFieldIdsPanel = async ({
  editorSdkProxy,
  hostname,
  i18n,
  initialData,
}: {
  editorSdkProxy: EditorSDK
  hostname: string
  i18n: I18nextProviderProps['i18n']
  initialData: FieldIdsPanelInitialData
}) => {
  editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: fieldIdsPanelDef.url,
      editorSdkProxy,
    }),
    initialData,
    width: 512,
    height: 330,
    //@ts-expect-error missing prop in editor-patform-sdk-types
    noPanelPadding: true,
    helpId: i18n.t('Manage_Content_Panel_Help_ID'),
    shouldHideHeader: true,
  })
}
